<template>
  <!-- Clinic and Specialities -->
  <section class="section section-specialities category-section">
    <div class="container">
      <div class="section-header text-center">
        <h3>Healthcare Category</h3>
      </div>
      <div class="row justify-content-center">
        <div class="col">
          <!-- Slider -->
          <slick
            class="specialities-slider slider addcursor"
            ref="slick"
            :options="slickOptions"
            v-if="categories !== undefined"
          >
            <!-- Slider Item -->
            <div
              class="speicality-item text-center"
              :class="{ active: activeitem === index }"
              v-for="(item, index) in categories"
              :key="index"
              @click="activeImage(index, item.category)"
            >
              <div class="speicality-img">
                <img
                  :src="'https://develop-physio.kneexpert.in' + item.image"
                  class="img-fluid"
                  height="90px"
                  width="90px"
                  alt="Speciality"
                />
              </div>
              <p>{{ item.category }}</p>
            </div>
            <!-- /Slider Item -->
          </slick>
          <!-- /Slider -->
        </div>
      </div>
    </div>
  </section>
  <!-- Clinic and Specialities -->
</template>
<script>
const images = require.context(
  "@/assets/img/specialities",
  false,
  /\.png$|\.jpg$/
);
import CommonApi from "../../services/CommonApi";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      categories: undefined,
      selected_category: "",
      activeitem: undefined,
      slickOptions: {
        slidesToShow: 7,
        infinite: false,
        dots: false,
        arrows: true,
        swipeToSlide: true,
        variableWidth: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  props: {
    complaints_treatment_offered: "",
  },
  mounted() {
    this.get_categories();
  },
  watch: {
    selected_category: function(val) {
      // this.$emit("update-category", val);
      this.$emit("update-sub-category", val);
      this.set_selected_category(val);
    },
    complaints_treatment_offered: function(val) {
      this.categories = undefined;
      this.get_categories();
    },
  },
  methods: {
    ...mapActions(["set_category_list", "set_selected_category"]),
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },
    reInit() {
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    loadImg(imgPath) {
      return images("./" + imgPath);
    },
    activeImage(id, category) {
      if (this.activeitem == id) {
        this.activeitem = undefined;
        this.selected_category = undefined;
      } else {
        this.activeitem = id;
        this.selected_category = category;
      }
    },
    async get_categories() {
      let param = {
        complaints_treatment_offered: this.complaints_treatment_offered,
      };
      param = new URLSearchParams(param);
      await CommonApi.get_data(
        "sahaj.finalapi.get_healthcare_categories",
        param
      ).then((res) => {
        if (res.status_code == 200) {
          this.categories = res.data;
          this.set_category_list(res.data);
        }
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/kneexpert/Cat.vue